/* Header search icon */
$(".header_search_icon, .header_search_icon_1").on("click", function(e){
    e.preventDefault();
    e.stopPropagation();
    $(".search_sec").toggle();
    $("body").toggleClass("search-active");
});

$(document).on("click", function(e){
    if (!$(e.target).closest(".site-search-handle, .search-results-container").length) {
        $(".search_sec").hide();
        $("body").removeClass("search-active");
    }
});

/* End */